module.exports = __webpack_public_path__ + "img/0018.5ed89dce.jpg";